import React, {Component} from 'react';
import PropTypes from 'prop-types';
import Chip from '@material-ui/core/Chip';
import moment from 'moment';
import ListItem from '@material-ui/core/ListItem';
import ReactGA from 'react-ga';
import {I18n} from 'react-redux-i18n';
import DateTimePicker from './DateTimePicker';

export default class DateTimeFilter extends Component {
  static propTypes = {
    onChange: PropTypes.func.isRequired,
    startTime: PropTypes.number.isRequired,
    endTime: PropTypes.number.isRequired
  }

  static ranges = {
    Today: {
      startTime: moment().startOf('day'),
      endTime: moment().endOf('day')
    },
    'Last 7 Days': {
      startTime: moment().subtract(6, 'days').startOf('day'),
      endTime: moment().endOf('day')
    },
    'Last 30 Days': {
      startTime: moment().subtract(29, 'days').startOf('day'),
      endTime: moment().endOf('day')
    },
    'Last Month': {
      startTime: moment().subtract(1, 'month').startOf('month'),
      endTime: moment().subtract(1, 'month').endOf('month')
    }
  }


  getChipTimeClass(period) {
    const times = DateTimeFilter.ranges[period];
    if (times) {
      if (times.startTime.valueOf() === this.props.startTime
        && times.endTime.valueOf() === this.props.endTime) {
        return 'librarylist__datechips-selected';
      }
    }

    return 'librarylist__datechips';
  }

  handleChipTime(type) {
    const times = DateTimeFilter.ranges[type];
    if (times) {
      const startTime = times.startTime.valueOf();
      const endTime = times.endTime.valueOf();
      this.props.onChange({startTime, endTime});
    }

    ReactGA.event({
      category: 'Library Filter',
      action: type,
      label: 'Filter Chips'
    });
  }


  handleOnChangedDate(date, convertedToTime) {
    const applyProperOnChange = {
      startTime: () => this.props.onChange({[date]: moment(convertedToTime).startOf('day').valueOf()}),
      endTime: () => this.props.onChange({[date]: moment(convertedToTime).endOf('day').valueOf()})
    };
    applyProperOnChange[date]();
    ReactGA.event({
      category: 'Library Filter',
      action: (date === 'startTime') ? 'Custom Start Date' : 'Custom End Date',
      label: 'Filter Chips'
    });
  }

  render() {
    return (
      <div>
        <ListItem>
          <DateTimePicker
            label={I18n.t('filter.date.startDateTime')}
            mode="start"
            onChange={e => this.handleOnChangedDate('startTime', e)}
            max={moment(this.props.endTime).startOf('day').valueOf()}
            min={moment().startOf('day').subtract(180, 'days').valueOf()}
            value={this.props.startTime}
            id="dateFilterStartTime"
          />
        </ListItem>
        <ListItem>
          <DateTimePicker
            label={I18n.t('filter.date.endDateTime')}
            mode="end"
            onChange={e => this.handleOnChangedDate('endTime', e)}
            value={this.props.endTime}
            max={moment().endOf('day').valueOf()}
            min={moment(this.props.startTime).endOf('day').valueOf()}
            id="dateFilterEndTime"
          />
        </ListItem>
        <ListItem className="librarylist__datechipscont">
          <Chip
            label={I18n.t('filter.date.range.last7days')}
            className={this.getChipTimeClass('Last 7 Days')}
            onClick={() => this.handleChipTime('Last 7 Days')}
            id="dateFilterLast7Days"
          />
          <Chip
            label={I18n.t('filter.date.range.last30days')}
            className={this.getChipTimeClass('Last 30 Days')}
            onClick={() => this.handleChipTime('Last 30 Days')}
            id="dateFilterLast30Days"
          />
          <Chip
            label={I18n.t('filter.date.range.lastMonth')}
            className={this.getChipTimeClass('Last Month')}
            onClick={() => this.handleChipTime('Last Month')}
            id="dateFilterLastMonth"
          />
        </ListItem>
      </div>
    );
  }
}
